/**
 * Small formatting helpers shared by the trace list / detail / drawer.
 *
 * Spec: dev/projects/sl2-sstv2-live-trace.md §4.1, §4.3
 */

/** "1.4 s" / "234 ms" / "-" */
export const fmtDuration = (ms?: number): string => {
  if (ms == null) return "-"
  if (ms < 1000) return `${ms} ms`
  return `${(ms / 1000).toFixed(2)} s`
}

/**
 * Lightweight relative-time. We avoid pulling moment in for one usage; the
 * rest of the wfe uses moment liberally so a small inline impl is fine.
 */
export const fmtRelative = (iso?: string, now: Date = new Date()): string => {
  if (!iso) return "-"
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return "-"
  const diffMs = now.getTime() - t
  const abs = Math.abs(diffMs)
  const sec = Math.round(abs / 1000)
  const min = Math.round(sec / 60)
  const hr = Math.round(min / 60)
  const day = Math.round(hr / 24)
  const sign = diffMs < 0 ? "in " : ""
  const suffix = diffMs < 0 ? "" : " ago"
  if (sec < 5) return "just now"
  if (sec < 60) return `${sign}${sec}s${suffix}`
  if (min < 60) return `${sign}${min}m${suffix}`
  if (hr < 24) return `${sign}${hr}h${suffix}`
  return `${sign}${day}d${suffix}`
}

export const fmtAbsolute = (iso?: string): string => {
  if (!iso) return "-"
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleString()
}

/** Render byte counts as KB/MB. */
export const fmtBytes = (n?: number): string => {
  if (n == null) return "-"
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
  return `${(n / 1024 / 1024).toFixed(1)} MB`
}
